const actionTypeIdentifier = 'B0C89E7E-436B-4BA5-B993-47BD1D39A3FC';

export const getArticleCatalogueMilestoneDetails = `SET-ARTICLE-CATALOGUE-MILESTONE-DETAILS-${actionTypeIdentifier}`;
export const setArticleCatalogueError = `SET-ARTICLE-CATALOGUE-ERROR-${actionTypeIdentifier}`;
export const getArticleCatalogueDropdownList = `GET-ARTICLE-CATALOGUE-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const getArticleDetailbyId = `GET-ARTICLE-DETAIL-BY-ID-${actionTypeIdentifier}`;
export const resetArticleCatalogueMilestoneForm = `RESET-ARTICLE-CATALOGUE-MILESTONE-FORM-${actionTypeIdentifier}`;
export const resetArticleComponentMilestoneForm = `RESET-ARTICLE-COMPONENT-MILESTONE-FORM-${actionTypeIdentifier}`;
export const getCountryCodeList =  `GET-COUNTRY-CODE-LIST-${actionTypeIdentifier}`;
export const getSalesOrganizationList =  `GET-SALES-ORGANIZATION-LIST-${actionTypeIdentifier}`;

export const articleCatalogueMilestoneModel = {
    articleId: 0,
    articleNumber: "",
    articleName: "",
    serviceFamily: "",
    salesOrganizationId: 0,
    salesOrganizationNumber: "",
    salesOrganizationName: "",
    salesOrganizationCountryCode: "",
    countryId: 0,
    countryCode: "",
    priceCalculationId: 0,
    priceCalculation: "",
    vatGroupId: 0,
    preArticleId: "",
    chargeTypeId: 0,
    chargeType: "",
    priceUnit: "",
    chargeCategoryId: 0,
    chargeCategory: "",
    fixedFee: "",
    isAlternateLogic: false,
    additionalAttribute: "",
    articleStatusId: 0,
    articleComponent: [],
    formula: "",
};